import * as React from 'react';
import * as styles from "./BasicCard.css";
import { Helper } from './../../Helper';
import {IAIcon} from '../icon/Icon'
import { LocalizationService } from '../../services/LocalizationService';

export interface IABasicCardProps {
    item?: any;
    title?: string;
    subtitle?:string;
    styles?: any;
    showSkeleton?: boolean;
    showCommandBarItems?: boolean;
    backgroundColor?: string;
    borderColor?: string;
    itemTitleColor?: string;
    itemTextColor?: string;
    itemTitleStyle?: string;
    itemTitleSize?: string;
    itemTitleAlign?: string;
    itemTitleWeight?: string;
    itemSubTitleSize?:string;
    onClickEdit?: (content: any) => void;
    onClickOpen?: (content: any) => void;
    onClickDelete?: (content: any) => void;
    onClickPreview?: (content: any) => void;
    onClickCopy?: (content: any) => void;
}

export interface IABasicCardState {
  commandaBarOpen: boolean;
}

export class IABasicCard extends React.Component<IABasicCardProps, IABasicCardState> {

  constructor(props: IABasicCardProps, state: IABasicCardState) {
    super(props, state);
    this.state = {
      commandaBarOpen: false
    }
    
  }

  public render(): JSX.Element {
    let commandBarItems: Array<any> = [];

    if (this.props.onClickEdit != undefined) {
      commandBarItems.push(
        <li onClick={() => this.props.onClickEdit(this.props.item)}>
          <IAIcon
            title="Edit"
            size={14}
            color={"#333333"}
          />
          <span>{new LocalizationService().strings.Messages_Categories_Edit}</span></li>
      );
    }
    if (this.props.onClickOpen != undefined) {
      commandBarItems.push(
        <li onClick={() => this.props.onClickOpen(this.props.item)}>
          <IAIcon
            title="Open"
            size={14}
            color={"#333333"}
          />
          <span>{new LocalizationService().strings.Messages_Categories_Open}</span></li>
      );
    }

    if (this.props.onClickPreview != undefined) {
      commandBarItems.push(
        <li onClick={() => this.props.onClickPreview(this.props.item)}>
          <IAIcon
            title="Preview"
            size={14}
            color={"#333333"}
          />
          <span>Preview</span></li>
      );
    }
    if (this.props.onClickCopy != undefined) {
      commandBarItems.push(
        <li onClick={() => this.props.onClickCopy(this.props.item)}>
          <IAIcon
            title="Copy"
            size={14}
            color={"#333333"}
          />
          <span>Copy</span></li>
      );
    }


    if (this.props.onClickDelete != undefined) {
      commandBarItems.push(
        <li onClick={() => this.props.onClickDelete(this.props.item)}>
          <IAIcon
            title="Close"
            size={14}
            color={"#333333"}
          />
          <span>{new LocalizationService().strings.Messages_Categories_Delete}</span></li>
      );
    }

    let textColor: string = this.props.backgroundColor != undefined ? Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.backgroundColor, "#ffffff", "#333333") : "#333333";

    return (
      <div
        className={styles.card}
        onClick={() => this.props.onClickOpen(this.props.item)}
        style={
          this.props.styles
        }
      >
      
        <div
          className={styles.textContent}
          style={{
            color: this.props.itemTextColor != undefined ? this.props.itemTextColor : textColor,
            backgroundColor: this.props.backgroundColor != undefined ? this.props.backgroundColor : '#ffffff',
          }}

        >
          <div
            className={styles.title}>
              {this.props.title}
          </div>

        {this.props.subtitle && 
          <div
            className={styles.subtitle} style={{fontSize: this.props.itemSubTitleSize ? this.props.itemSubTitleSize : '12px'}}>
              {this.props.subtitle}
          </div>
        }
        </div>
        {this.props.showSkeleton &&
          <div className={styles.skeleton} />
        }
        <div className={styles.cardFooter}>
        {this.props.showCommandBarItems &&
          <div className={styles.cardContainer} onClick={(e) => {
            e.stopPropagation();
            this.setState({ commandaBarOpen: !this.state.commandaBarOpen })
          }
          }>
          <div className={styles.cardBarBtn}>
            <IAIcon
            title="More"
            size={15}
            color={"#333333"}
          /></div>
          {this.state.commandaBarOpen && <ul className={styles.cardBarItems}>
              {commandBarItems}
            </ul>}
          </div>
        }
        </div>
      </div>
    );
  }
}             